import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Support from "../../store/SupportTab";
import { ApplicationState } from "../../store";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds } from "../../config/UserServicesList";
import SupportNew from "./Support";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useTranslation } from "react-i18next";

const BreachSupportTab = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const dispatch = useDispatch();
    const breachActiveServices = useAreServicesActive([ezsServiceIds.businessBreachFulfillmentSupport]);
    let ClaimFriendlyName;
    let ClaimFriendlyPhoneNumber;
    const PartnerName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const PartnerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const RetailerName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerName
            ? state.configurationState.configuration.partnerConfig.retailerName
            : ""
    );
    const RetailerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            ? state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            : ""
    );

    if (RetailerName && RetailerPhoneNumber) {
        ClaimFriendlyName = RetailerName;
        ClaimFriendlyPhoneNumber = RetailerPhoneNumber;
    } else {
        ClaimFriendlyName = PartnerName;
        ClaimFriendlyPhoneNumber = PartnerPhoneNumber;
    }

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1>{tLang("supportSection.supportTitleText")}</h1>
                </div>
            </div>

            <Support selectedTab={breachActiveServices ? "2" : "1"} />

            {breachActiveServices ? (
                <div className="support-container row">
                    <div className="col-xs-12 row">
                        <div className="box no-padding">
                            <div className="contentBox">
                                <h2>{tLang("supportSection.breachSupportWidget.title")}</h2>
                                <p className="sectionPara">{tLang("supportSection.breachSupportWidget.message1")}</p>
                                <p>{tLang("supportSection.breachSupportWidget.message2")}</p>
                                <p><u>{tLang("supportSection.breachSupportWidget.ExclusionsMessage")}</u></p>
                            </div>
                            <div className="contentBox">
                                <h3>{tLang("supportSection.breachSupportWidget.stepOneTitle")}:</h3>
                                <p className="sectionPara">
                                    {tLang("supportSection.breachSupportWidget.stepOneMessage1", { ClaimFriendlyName: ClaimFriendlyName })}
                                </p>
                            </div>
                            <div className="contentBox">
                                <h3> {tLang("supportSection.breachSupportWidget.stepTwoTitle")}:</h3>
                                <p className="sectionPara">
                                    {tLang("supportSection.breachSupportWidget.stepTwoMessage1", { ClaimFriendlyName: ClaimFriendlyName })}
                                </p>
                                <p className="sectionPara">{tLang("supportSection.breachSupportWidget.stepTwoMessage2")}</p>
                            </div>
                            <div className="contentBox">
                                <h2> {tLang("supportSection.breachSupportWidget.breachFullfillmentTitle")}</h2>
                                <p className="sectionPara">{tLang("supportSection.breachSupportWidget.breachFullfillmentmessage")}</p>
                            </div>
                            <div className="contentBox">
                                <h2>{tLang("supportSection.breachSupportWidget.notificationTitle")}</h2>
                                <p className="sectionPara">{tLang("supportSection.breachSupportWidget.notificationMessage")}</p>
                            </div>
                            <div className="contentBox">
                                <h2>{tLang("supportSection.breachSupportWidget.expertCareTitle")}</h2>
                                <p className="sectionPara">{tLang("supportSection.breachSupportWidget.expertCareMessage")}</p>
                            </div>
                            <div className="contentBox">
                                <h2>{tLang("supportSection.breachSupportWidget.monitoringTitle")}</h2>
                                <p className="sectionPara">{tLang("supportSection.breachSupportWidget.monitoringMessage")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="support-container row">
                    <div className="col-xs-12 row">
                        <div className="contentBox">
                            <SupportNew setForm="" setSupportIdentityThreatState="" supportIdentityThreatState="" onClose="" />
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default BreachSupportTab;
